module.exports = __webpack_public_path__ + "img/brand-cut.501ef757.png";